import { Navigate } from 'react-router';

/** `/projects` without an id → the project list on Sākums (FR-PRJ-013). */
export function ProjectsIndexPage() {
  return <Navigate to="/" replace />;
}
